import { useQuery } from '@tanstack/react-query';
import { getMenuConfig } from '@/api/menu';
import { useAuth } from './useAuth';

export function useMenuConfig() {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: ['menu-config'],
    queryFn: getMenuConfig,
    enabled: isAuthenticated,
    staleTime: Infinity,
  });
}
